// src/app/core/app-config.token.ts
import { InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';

export interface AppConfig {
    production: boolean;
    name: string;
    basepath: string;
    appUrl: string;
    apiUrl: string;
    loginUrl: string;
    editUrl: string;
    twoFactorUrl: string;
    fileServer: string;
    globalProcessId: string;
    globalLanguages: string[];
    groupsUrl: string;
    signatureCheckFirm: string;
    stripeKey: string;
    fesPrice: number,
    qesPrice: number,

    domain: string;
    onpremise: boolean;
    // alles Weitere darf draufliegen (qesPrice, features, ...)
    [key: string]: any;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG', {
    providedIn: 'root',
    factory: () => environment as AppConfig,
});
